import axiosInstance from "../../utils/axios";

export const authApi = {
  login: (payload) => {
    return axiosInstance.post("/api/Authentication/login", payload);
  },

  register: (payload) => {
    return axiosInstance.post("/api/Authentication/register", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
